import { Order, OrderStatus } from "../models/analytics";
import { DateRange } from "../models/filters";

const QUALIFYING_STATUSES: OrderStatus[] = [
  "UNFULFILLED",
  "PARTIALLY_FULFILLED",
  "FULFILLED",
];

// Simple deterministic pseudo-random generator based on a seed
function mulberry32(seed: number) {
  return function () {
    let t = (seed += 0x6d2b79f5);

    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);

    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function dateRangeDays(range: DateRange): string[] {
  const start = new Date(range.from + "T00:00:00.000Z");
  const end = new Date(range.to + "T00:00:00.000Z");
  const days: string[] = [];

  for (let d = new Date(start); d <= end; d.setUTCDate(d.getUTCDate() + 1)) {
    days.push(d.toISOString().substring(0, 10));
  }

  return days;
}

export function generateMockOrders(range: DateRange, channelId?: string | null): Order[] {
  const days = dateRangeDays(range);
  const seedBase = parseInt(days[0].replace(/-/g, ""), 10) || 12345;
  const rand = mulberry32(seedBase);

  const orders: Order[] = [];

  days.forEach((day) => {
    // 3-14 orders per day
    const orderCount = 3 + Math.floor(rand() * 12);

    for (let i = 0; i < orderCount; i++) {
      const r = rand();
      const status: OrderStatus = r < 0.05 ? "CANCELED" : QUALIFYING_STATUSES[Math.floor(rand() * QUALIFYING_STATUSES.length)];
      const gross = Math.round((50 + rand() * 450) * 100) / 100; // $50 - $500

      orders.push({
        id: `${day}-${i}`,
        created: day,
        channelId: channelId ?? "mock-channel",
        status,
        gross,
      });
    }
  });

  return orders;
}
